// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notesSection__hhCfU {
  display: flex;
  flex-direction: column;
  background-color: var(--tables-secondary-row-sub-title-surface);
  padding: 20px 25px;
  gap: 20px;
  box-shadow: var(--info-block-box-shadow);
}

.blockHead__QCScb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__kWqN8 {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
}

.linksLabel__uXZCs {
  display: block;
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  margin-bottom: 8px;
}

.linksTableWrapper__SlLZU {
  max-height: 230px;
  overflow: auto;
}
.linksTableWrapper__SlLZU::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.linksTableWrapper__SlLZU::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.linksTableWrapper__SlLZU::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.linksTableWrapper__SlLZU::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.link__fFShw {
  color: var(--buttons-surface);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--tables-primary-row-stroke);
  padding: 15px 25px;
  background-color: var(--tables-primary-row-surface-default);
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
}
.link__fFShw:not(:last-child) {
  margin-bottom: -1px;
}

.linkIcon__Ebs5P path {
  fill: var(--buttons-surface);
}

.emptyLink___kquI {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--inputs-filled-text);
  padding: 15px 25px;
  border-radius: 2px;
  background-color: var(--tables-primary-row-surface-default);
}

.emptyBlock__wsJOi {
  font-size: 11px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
}

.emptyBlockTitle__QrbRn {
  font-weight: 500;
  line-height: 14px;
}

.emptyBlockDescr__EYCna {
  color: var(--tables-primary-row-text-additional);
  line-height: 12px;
  margin-top: 4px;
  letter-spacing: 0.11px;
}

.buttonBlock__NUfrY {
  margin-top: 20px;
}

.fieldLabel__IZyU9 {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 6px;
}

.fieldInfo__nzqQC {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--inputs-filled-text);
  min-height: 100px;
  padding: 12px 15px;
  border-radius: 2px;
  background-color: var(--tables-primary-row-surface-default);
  overflow-y: auto;
}
.fieldInfo__nzqQC::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.fieldInfo__nzqQC::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.fieldInfo__nzqQC::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.fieldInfo__nzqQC::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
.fieldInfo__nzqQC p {
  margin: 0;
}
.fieldInfo__nzqQC img {
  width: 100%;
  height: 100%;
  max-width: 130px;
  object-fit: cover;
  cursor: zoom-in;
  margin-top: 10px;
  margin-right: 10px;
}
.fieldInfo__nzqQC video {
  width: 100%;
  min-height: 300px;
  display: block;
}

.attachedFilesWrapper__aQv3q {
  padding: unset;
  background: unset;
  margin-top: 6px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/components/NotesSection/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,+DAAA;EACA,kBAAA;EACA,SAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,0CAAA;AAzEF;;AA4EA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,iBAAA;EACA,cAAA;AAzEF;AAVE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAYJ;AATE;EACE,+BAAA;EACA,kBAAA;AAWJ;AARE;EACE,8BAAA;EACA,kBAAA;AAUJ;AAPE;EACE,gBAAA;EACA,kBAAA;AASJ;;AA6EA;EACE,6BAAA;EAhBA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kDAAA;EACA,kBAAA;EACA,2DAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAzDF;AA2DE;EACE,mBAAA;AAzDJ;;AAoEE;EACE,4BAAA;AAjEJ;;AAqEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,2DAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAlEF;;AAqEA;EACE,gBAAA;EACA,iBAAA;AAlEF;;AAqEA;EACE,gDAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;AAlEF;;AAqEA;EACE,gBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2DAAA;EACA,gBAAA;AAlEF;AAxGE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA0GJ;AAvGE;EACE,+BAAA;EACA,kBAAA;AAyGJ;AAtGE;EACE,8BAAA;EACA,kBAAA;AAwGJ;AArGE;EACE,gBAAA;EACA,kBAAA;AAuGJ;AAsDI;EACE,SAAA;AApDN;AAuDI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AArDN;AAwDI;EACE,WAAA;EACA,iBAAA;EACA,cAAA;AAtDN;;AA2DA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAxDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.notesSection {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  padding: 20px 25px;\n  gap: 20px;\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.blockHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n}\n\n.linksLabel {\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  margin-bottom: 8px;\n}\n\n.linksTableWrapper {\n  max-height: 230px;\n  overflow: auto;\n\n  @include scrollBar;\n}\n\n@mixin link {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid var(--tables-primary-row-stroke);\n  padding: 15px 25px;\n  background-color: var(--tables-primary-row-surface-default);\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 500;\n\n  &:not(:last-child) {\n    margin-bottom: -1px;\n  }\n}\n\n.link {\n  color: var(--buttons-surface);\n\n  @include link;\n}\n\n.linkIcon {\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.emptyLink {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--inputs-filled-text);\n  padding: 15px 25px;\n  border-radius: 2px;\n  background-color: var(--tables-primary-row-surface-default);\n}\n\n.emptyBlock {\n  font-size: 11px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 50px 0;\n}\n\n.emptyBlockTitle {\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.emptyBlockDescr {\n  color: var(--tables-primary-row-text-additional);\n  line-height: 12px;\n  margin-top: 4px;\n  letter-spacing: 0.11px;\n}\n\n.buttonBlock {\n  margin-top: 20px;\n}\n\n.fieldLabel {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 6px;\n}\n\n.fieldInfo {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--inputs-filled-text);\n  min-height: 100px;\n  padding: 12px 15px;\n  border-radius: 2px;\n  background-color: var(--tables-primary-row-surface-default);\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  :global {\n    p {\n      margin: 0;\n    }\n\n    img {\n      width: 100%;\n      height: 100%;\n      max-width: 130px;\n      object-fit: cover;\n      cursor: zoom-in;\n      margin-top: 10px;\n      margin-right: 10px;\n    }\n\n    video {\n      width: 100%;\n      min-height: 300px;\n      display: block;\n    }\n  }\n}\n\n.attachedFilesWrapper {\n  padding: unset;\n  background: unset;\n  margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notesSection": `notesSection__hhCfU`,
	"blockHead": `blockHead__QCScb`,
	"blockTitle": `blockTitle__kWqN8`,
	"linksLabel": `linksLabel__uXZCs`,
	"linksTableWrapper": `linksTableWrapper__SlLZU`,
	"link": `link__fFShw`,
	"linkIcon": `linkIcon__Ebs5P`,
	"emptyLink": `emptyLink___kquI`,
	"emptyBlock": `emptyBlock__wsJOi`,
	"emptyBlockTitle": `emptyBlockTitle__QrbRn`,
	"emptyBlockDescr": `emptyBlockDescr__EYCna`,
	"buttonBlock": `buttonBlock__NUfrY`,
	"fieldLabel": `fieldLabel__IZyU9`,
	"fieldInfo": `fieldInfo__nzqQC`,
	"attachedFilesWrapper": `attachedFilesWrapper__aQv3q`
};
module.exports = ___CSS_LOADER_EXPORT___;
